import { useTranslation } from 'react-i18next';
import { useAudiences } from '../../../../models/audiences/context';
import TopicPickerCard from './topic-picker-card';
import AudiencePicker from './audience-picker';
import './deliver-section.scss';

type DeliverSectionProps = {
  showAudiencePicker: boolean;
};

const DeliverSection = ({ showAudiencePicker }: DeliverSectionProps) => {
  const { t } = useTranslation();
  const { audiences: programAudiences } = useAudiences();
  const showAudience = showAudiencePicker && programAudiences.length > 0;

  return (
    <div className="ugc-deliver-section">
      <div className="ugc-deliver-section__heading text-subheading-bold">
        {t('user_generated_content.deliver')}
      </div>
      <TopicPickerCard />
      {showAudience && <AudiencePicker />}
    </div>
  );
};

export default DeliverSection;
